$(document).ready(function()
{
    
    if (jQuery('.timeline').length)
    {
        /* Every time the window is scrolled ... */
        $(window).scroll( function(){
        
            /* Check the location of each desired element */
            $('.hide-from-view').each( function(i){
                
                var top_of_object = $(this).position().top + 50; // a wee bit lower
                var bottom_of_window = $(window).scrollTop() + $(window).height();
                
                /* If the object is completely visible in the window, fade it it */
                if( bottom_of_window > top_of_object ){
                    
                    $(this).animate({'opacity':'1'}, 2500);
                        
                }
                
            }); 
        
        });

    }
    
});